import { BookingLocationType, type BookingProposalRecord } from '@navio/nsdk';
import type { ProposalAnalyticsProps } from 'noddi-web';
import { isRecallProposalType } from './bookingProposalType';
import { showsSuggestedProposalTimes } from './stationaryProposalPolicy';
import { getProposalUserGroupContext } from './userGroupContext';

/**
 * The dimensions every proposal event carries. Derived once from the record the
 * flow wrapper already holds, then kept on the proposal store so steps that never
 * fetch the proposal (address, login, builder) report the same breakdown.
 */
export const getProposalAnalyticsProps = (proposal: BookingProposalRecord): ProposalAnalyticsProps => {
  const brand = proposal.serviceDepartment.brand.domain;
  const isStationary = proposal.bookingLocationType === BookingLocationType.STATIONARY;

  return {
    proposalId: proposal.id,
    proposalType: proposal.type.value,
    isRecall: isRecallProposalType(proposal.type.value),
    locationType: isStationary ? 'stationary' : 'mobile',
    customerType: getProposalUserGroupContext(proposal.organization),
    brand,
    serviceDepartmentId: proposal.serviceDepartment.id,
    serviceDepartmentName: proposal.serviceDepartment.userGroup.name,
    usesSuggestedTimes: isStationary && showsSuggestedProposalTimes(brand)
  };
};
